<template>
    <div>
        <div class="hb-primary hb-design-system-border-radius px-4 white--text">
            <hb-header :divider="false">
                <hb-page-header title="Mini Profile">
                    <template v-slot:description>
                        import { HbMiniProfile, HbMiniProfileItem } from 'hummingbird-aviary';
                    </template>
                </hb-page-header>
            </hb-header>
        </div>

        <hb-tabs v-model="activeTab">
            <v-tab
                :ripple="false"
            >
                Prototype
            </v-tab>
            <v-tab
                :ripple="false"
            >
                Examples
            </v-tab>
            <v-tab
                :ripple="false"
            >
                Props, Slots &amp; Events
            </v-tab>

        </hb-tabs>

        <v-divider></v-divider>

        <div v-if="activeTab === 0" class="pt-3">

            <v-row no-gutters>
                <v-col cols="8" class="pt-3 pr-6">
                    <hb-card no-title class="pa-3">
                        <hb-mini-profile
                            :type="type"
                            :disable-click="disableClick"
                            :thumbnail="thumbnail"
                            :disable-thumbnail="disableThumbnail"
                            :do-not-rent="doNotRent"
                            :id-verified="idVerified"
                            :disable-avatar-click="disableAvatarClick"
                            :title="title"
                            :bankrupt="bankrupt"
                            :military="military"
                            :status="status"
                            :disable-status="disableStatus"
                            :past-due-amount="pastDueAmount"
                            :disable-report="disableReport"
                            :business-name="businessName"
                            :representative-name="representativeName"
                            :phone="phone"
                            :allow-phone-click="allowPhoneClick"
                            :can-text="canText"
                            :email="email"
                            :allow-email-click="allowEmailClick"
                            :address="address"
                            :space-is-occupied="spaceIsOccupied"
                            :tenant-name="tenantName"
                            :tenant-is-account="tenantIsAccount"
                            :tenant-is-business="tenantIsBusiness"
                            :space-type="spaceType"
                            :space-category="spaceCategory"
                            :space-featured-amenity="spaceFeaturedAmenity"
                            :space-property-info="spacePropertyInfo"
                            :contact-space-type="contactSpaceType"
                            :contact-space-number="contactSpaceNumber"
                            :disable-contact-space-link="disableContactSpaceLink"
                            :contact-space-category="contactSpaceCategory"
                            :contact-space-featured-amenity="contactSpaceFeaturedAmenity"
                            :contact-space-property-info="contactSpacePropertyInfo"
                            :contact-space-access-code="contactSpaceAccessCode"
                            :contact-space-lockout="contactSpaceLockout"
                            :disable-contact-space-access-click="disableContactSpaceAccessClick"
                            :disable-contact-space-info="disableContactSpaceInfo"
                            :use-menu="useMenu"
                            :menu-icon-type="menuIconType"
                            :contact-space-count="contactSpaceCount"
                            :contact-space-count-other-properties="contactSpaceCountOtherProperties"
                            :contact-active-lead-count="contactActiveLeadCount"
                            :is-lead="isLead"
                            :lead-type="leadType"
                            :disable-lead-link="disableLeadLink"
                            :lead-space-type="leadSpaceType"
                            :lead-space-number="leadSpaceNumber"
                            :lead-space-category="leadSpaceCategory"
                            :lead-featured-amenity="leadFeaturedAmenity"
                            :lead-property-info="leadPropertyInfo"
                            :disable-lead-info="disableLeadInfo"
                            :account-space-type="accountSpaceType"
                            :account-space-count="accountSpaceCount"
                            :account-size="accountSize"
                            :account-total-monthly-spent="accountTotalMonthlySpent"
                            :disable-account-info="disableAccountInfo"
                            @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                            @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                            @phone-call-click="handleEmittedClickEvent('@phone-call-click', 'HbMiniProfile')"
                            @phone-text-click="handleEmittedClickEvent('@phone-text-click', 'HbMiniProfile')"
                            @email-click="handleEmittedClickEvent('@email-click', 'HbMiniProfile')"
                            @contact-space-click="handleEmittedClickEvent('@contact-space-click', 'HbMiniProfile')"
                            @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfile')"
                            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfile')"
                        >
                            <template v-slot:reportTooltipBody v-if="reportTooltipBody">
                                <div v-html="reportTooltipBody"></div>
                            </template>

                            <template v-slot:menuSpaces>

                                <HbMiniProfileItem
                                    type="space"
                                    space-type="storage"
                                    space-number="100"
                                    space-category="10' x 10'"
                                    space-featured-amenity="Climate Controlled"
                                    space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                    space-access-code="12345"
                                    space-status="Current"
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                    @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
                                    @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                                />

                                <HbMiniProfileItem
                                    type="space"
                                    space-type="storage"
                                    space-number="101"
                                    space-category="10' x 10'"
                                    space-featured-amenity="Climate Controlled"
                                    space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                    space-access-code="23451"
                                    space-lockout
                                    space-status="Active Lien"
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                    @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
                                    @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                                />
                            </template>

                            <template v-slot:menuSpacesOtherProperties>

                                <HbMiniProfileItem
                                    type="space"
                                    space-type="locker"
                                    space-number="200"
                                    space-category="10' x 10'"
                                    space-featured-amenity="Climate Controlled"
                                    space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
                                    space-access-code="34512"
                                    space-status="Current"
                                    disable-space-link
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                    @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                                />

                                <HbMiniProfileItem
                                    type="space"
                                    space-type="parking"
                                    space-number="201"
                                    space-category="10' x 10'"
                                    space-featured-amenity="Climate Controlled"
                                    space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
                                    space-access-code="45231"
                                    space-lockout
                                    space-status="Active Lien"
                                    disable-space-link
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                    @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                                />

                            </template>

                            <template v-slot:menuActiveLeads>

                                <HbMiniProfileItem
                                    type="lead"
                                    lead-type="Reservation"
                                    lead-space-type="storage"
                                    lead-space-number="100"
                                    lead-space-category="10' x 10'"
                                    lead-featured-amenity="Climate Controlled"
                                    lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                    @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
                                />

                                <HbMiniProfileItem
                                    type="lead"
                                    lead-type="Reservation"
                                    lead-space-type="parking"
                                    lead-space-number="101"
                                    lead-space-category="10' x 10'"
                                    lead-featured-amenity="Elevator Access"
                                    lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                    @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
                                />

                            </template>

                            <template v-slot:menuClosedLeases>

                                <HbMiniProfileItem
                                    type="closed"
                                    closed-space-type="storage"
                                    :closed-count="5"
                                    closed-status="Balance Due"
                                    @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                />

                            </template>

                        </hb-mini-profile>
                    </hb-card>

                    <v-row no-gutters>

                        <v-col cols="6" class="pr-6 pt-6">

                            <hb-card color="#E0F5F5" title="Code + Data">
                                <pre class="px-4" :style="prototypeCodeExpanded ? 'height:auto' : 'height:479px;'">
                                    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="prototypeCodeExpanded = !prototypeCodeExpanded">
                                        {{ prototypeCodeExpanded ? 'Collapse Code' : 'Expand Code' }}
                                        <HbIcon class="pl-1" :mdi-code="prototypeCodeExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                                    </div>
&lt;hb-mini-profile
    type="{{ type }}"<span v-if="disableClick"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-click</span><span v-if="thumbnail"><br />&nbsp;&nbsp;&nbsp;&nbsp;thumbnail="{{ thumbnail }}"</span><span v-if="disableThumbnail"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-thumbnail</span><span v-if="doNotRent"><br />&nbsp;&nbsp;&nbsp;&nbsp;do-not-rent</span><span v-if="type !== 'space' && idVerified"><br />&nbsp;&nbsp;&nbsp;&nbsp;id-verified</span><span v-if="disableAvatarClick"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-avatar-click</span><span v-if="title"><br />&nbsp;&nbsp;&nbsp;&nbsp;title="{{ title }}"</span><span v-if="type !== 'space' && bankrupt"><br />&nbsp;&nbsp;&nbsp;&nbsp;bankrupt</span><span v-if="type !== 'space' && military"><br />&nbsp;&nbsp;&nbsp;&nbsp;military</span><span v-if="status"><br />&nbsp;&nbsp;&nbsp;&nbsp;status="{{ status }}"</span><span v-if="disableStatus"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-status</span><span v-if="pastDueAmount && type !== 'space'"><br />&nbsp;&nbsp;&nbsp;&nbsp;past-due-amount="{{ pastDueAmount }}"</span><span v-if="disableReport && type !== 'space'"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-report</span><span v-if="type === 'space' && spaceIsOccupied"><br />&nbsp;&nbsp;&nbsp;&nbsp;space-is-occupied</span><span v-if="(type === 'space' && spaceIsOccupied) || type !== 'space'"><span v-if="businessName"><br />&nbsp;&nbsp;&nbsp;&nbsp;business-name="{{ businessName }}"</span><span v-if="representativeName"><br />&nbsp;&nbsp;&nbsp;&nbsp;representative-name="{{ representativeName }}"</span><span v-if="tenantName && type === 'space'"><br />&nbsp;&nbsp;&nbsp;&nbsp;tenant-name="{{ tenantName }}"</span><span v-if="type === 'space' && tenantIsAccount"><br />&nbsp;&nbsp;&nbsp;&nbsp;tenant-is-account</span><span v-if="type === 'space' && tenantIsBusiness"><br />&nbsp;&nbsp;&nbsp;&nbsp;tenant-is-business</span><span v-if="phone"><br />&nbsp;&nbsp;&nbsp;&nbsp;phone="{{ phone }}"</span><span v-if="allowPhoneClick"><br />&nbsp;&nbsp;&nbsp;&nbsp;allow-phone-click</span><span v-if="canText !== null"><br />&nbsp;&nbsp;&nbsp;&nbsp;{{ canText ? 'can-text' : ':can-text="false' }}</span><span v-if="email"><br />&nbsp;&nbsp;&nbsp;&nbsp;email="{{ email }}"</span><span v-if="allowEmailClick"><br />&nbsp;&nbsp;&nbsp;&nbsp;allow-email-click</span><span v-if="address"><br />&nbsp;&nbsp;&nbsp;&nbsp;address="{{ address }}"</span></span><span v-if="type === 'space'"><span v-if="spaceType"><br />&nbsp;&nbsp;&nbsp;&nbsp;space-type="{{ spaceType }}"</span><span v-if="spaceCategory"><br />&nbsp;&nbsp;&nbsp;&nbsp;space-category="{{ spaceCategory }}"</span><span v-if="spaceFeaturedAmenity"><br />&nbsp;&nbsp;&nbsp;&nbsp;space-featured-amenity="{{ spaceFeaturedAmenity }}"</span><span v-if="spacePropertyInfo"><br />&nbsp;&nbsp;&nbsp;&nbsp;space-property-info="{{ spacePropertyInfo }}"</span></span><span v-if="type === 'contact' || type === 'business'"><span v-if="disableContactSpaceInfo && !isLead"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-contact-space-info</span><span v-if="useMenu && !disableContactSpaceInfo && !isLead"><br />&nbsp;&nbsp;&nbsp;&nbsp;use-menu</span><span v-if="isLead"><br />&nbsp;&nbsp;&nbsp;&nbsp;is-lead</span><span v-if="!useMenu && !disableContactSpaceInfo && !isLead"><span v-if="contactSpaceType"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-type="{{ contactSpaceType }}"</span><span v-if="contactSpaceNumber"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-number="{{ contactSpaceNumber }}"</span><span v-if="disableContactSpaceLink"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-contact-space-link</span><span v-if="contactSpaceCategory"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-category="{{ contactSpaceCategory }}"</span><span v-if="contactSpaceFeaturedAmenity"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-featured-amenity="{{ contactSpaceFeaturedAmenity }}"</span><span v-if="contactSpacePropertyInfo"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-property-info="{{ contactSpacePropertyInfo }}"</span><span v-if="contactSpaceAccessCode"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-access-code="{{ contactSpaceAccessCode }}"</span><span v-if="contactSpaceLockout"><br />&nbsp;&nbsp;&nbsp;&nbsp;contact-space-lockout</span><span v-if="disableContactSpaceAccessClick"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-contact-space-access-click</span></span><span v-if="useMenu && !disableContactSpaceInfo && !isLead"><span v-if="menuIconType"><br />&nbsp;&nbsp;&nbsp;&nbsp;menu-icon-type="{{ menuIconType }}"</span><span v-if="contactSpaceCount && contactSpaceCount > 0"><br />&nbsp;&nbsp;&nbsp;&nbsp;:contact-space-count="{{ contactSpaceCount }}"</span><span v-if="contactSpaceCountOtherProperties && contactSpaceCountOtherProperties > 0"><br />&nbsp;&nbsp;&nbsp;&nbsp;:contact-space-count-other-properties="{{ contactSpaceCountOtherProperties }}"</span><span v-if="contactActiveLeadCount && contactActiveLeadCount > 0"><br />&nbsp;&nbsp;&nbsp;&nbsp;:contact-active-lead-count="{{ contactActiveLeadCount }}"</span></span></span><span v-if="type === 'lead' || ((type === 'contact' || type === 'business') && isLead)"><span v-if="disableLeadInfo"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-lead-info</span><span v-if="!disableLeadInfo"><span v-if="leadType"><br />&nbsp;&nbsp;&nbsp;&nbsp;lead-type="{{ leadType }}"</span><span v-if="disableLeadLink"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-lead-link</span><span v-if="leadSpaceType"><br />&nbsp;&nbsp;&nbsp;&nbsp;lead-space-type="{{ leadSpaceType }}"</span><span v-if="leadSpaceNumber"><br />&nbsp;&nbsp;&nbsp;&nbsp;lead-space-number="{{ leadSpaceNumber }}"</span><span v-if="leadSpaceCategory"><br />&nbsp;&nbsp;&nbsp;&nbsp;lead-space-category="{{ leadSpaceCategory }}"</span><span v-if="leadFeaturedAmenity"><br />&nbsp;&nbsp;&nbsp;&nbsp;lead-featured-amenity="{{ leadFeaturedAmenity }}"</span><span v-if="leadPropertyInfo"><br />&nbsp;&nbsp;&nbsp;&nbsp;lead-property-info="{{ leadPropertyInfo }}"</span></span></span><span v-if="type === 'account'"><span v-if="disableAccountInfo"><br />&nbsp;&nbsp;&nbsp;&nbsp;disable-account-info</span><span v-if="!disableAccountInfo"><span v-if="accountSpaceType"><br />&nbsp;&nbsp;&nbsp;&nbsp;account-space-type="{{ accountSpaceType }}"</span><span v-if="accountSpaceCount"><br />&nbsp;&nbsp;&nbsp;&nbsp;:account-space-count="{{ accountSpaceCount }}"</span><span v-if="accountSize"><br />&nbsp;&nbsp;&nbsp;&nbsp;account-size="{{ accountSize }}"</span><span v-if="accountTotalMonthlySpent"><br />&nbsp;&nbsp;&nbsp;&nbsp;account-total-monthly-spent="{{ accountTotalMonthlySpent }}"</span></span></span>
    @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
    @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
    @phone-call-click="handleEmittedClickEvent('@phone-call-click', 'HbMiniProfile')"
    @phone-text-click="handleEmittedClickEvent('@phone-text-click', 'HbMiniProfile')"
    @email-click="handleEmittedClickEvent('@email-click', 'HbMiniProfile')"
    @contact-space-click="handleEmittedClickEvent('@contact-space-click', 'HbMiniProfile')"
    @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfile')"
    @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfile')"
>
<span v-if="reportTooltipBody && type !== 'space'">
    &lt;template v-slot:reportTooltipBody>
        {{ reportTooltipBody }}
    &lt;/template>
</span><span v-if="useMenu && (type === 'contact' || type === 'business') && !isLead">
    &lt;template v-slot:menuSpaces>

        &lt;HbMiniProfileItem
            type="space"
            space-type="storage"
            space-number="100"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            space-access-code="12345"
            space-status="Current"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />

        &lt;HbMiniProfileItem
            type="space"
            space-type="storage"
            space-number="101"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            space-access-code="23451"
            space-lockout
            space-status="Active Lien"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />
    &lt;/template>

    &lt;template v-slot:menuSpacesOtherProperties>

        &lt;HbMiniProfileItem
            type="space"
            space-type="storage"
            space-number="200"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
            space-access-code="34512"
            space-status="Current"
            disable-space-link
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />

        &lt;HbMiniProfileItem
            type="space"
            space-type="parking"
            space-number="201"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
            space-access-code="45231"
            space-lockout
            space-status="Active Lien"
            disable-space-link
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />

    &lt;/template>

    &lt;template v-slot:menuActiveLeads>

        &lt;HbMiniProfileItem
            type="lead"
            lead-type="Reservation"
            lead-space-type="storage"
            lead-space-category="10' x 10'"
            lead-featured-amenity="Climate Controlled"
            lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
        />

        &lt;HbMiniProfileItem
            type="lead"
            lead-type="Reservation"
            lead-space-type="parking"
            lead-space-category="10' x 10'"
            lead-featured-amenity="Elevator Access"
            lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
        />

    &lt;/template>
    
    &lt;template v-slot:menuClosedLeases>

        &lt;HbMiniProfileItem
            type="closed"
            closed-space-type="storage"
            :closed-count="5"
            closed-status="Balance Due"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
        />

    &lt;/template></span>
&lt;/hb-mini-profile>
                                </pre>
                            </hb-card>

                        </v-col>

                        <v-col cols="6" class="pt-6">

                            <hb-card title="Props">

                                <hb-form label="type">
                                    <HbSelect
                                        v-model="type"
                                        :items="types"
                                        placeholder="Select Type"
                                        :clearable="false"
                                    />
                                </hb-form>

                                <hb-form label="disable-click">
                                    <HbSwitch
                                        v-model="disableClick"
                                        :label="disableClick ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="thumbnail">
                                    <HbTextField
                                        v-model="thumbnail"
                                        placeholder="Enter Thumbnail Url"
                                        clearable
                                    />
                                </hb-form>

                                <hb-form label="disable-thumbnail">
                                    <HbSwitch
                                        v-model="disableThumbnail"
                                        :label="disableThumbnail ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="do-not-rent">
                                    <template v-slot:tooltipBody>
                                        "do-not-rent" prop takes priority over "id-verified" prop for display purposes
                                    </template>
                                    <HbSwitch
                                        v-model="doNotRent"
                                        :label="doNotRent ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="id-verified" v-if="type !== 'space'">
                                    <HbSwitch
                                        v-model="idVerified"
                                        :label="idVerified ? 'true' : 'false/null'"
                                        :disabled="doNotRent"
                                    />
                                </hb-form>

                                <hb-form label="disable-avatar-click">
                                    <HbSwitch
                                        v-model="disableAvatarClick"
                                        :label="disableAvatarClick ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="title">
                                    <HbTextField
                                        v-model="title"
                                        placeholder="Enter Title"
                                    />
                                </hb-form>

                                <span v-if="type !== 'space'">

                                    <hb-form label="bankrupt">
                                        <HbSwitch
                                            v-model="bankrupt"
                                            :label="bankrupt ? 'true' : 'false/null'"
                                        />
                                    </hb-form>

                                    <hb-form label="military">
                                        <HbSwitch
                                            v-model="military"
                                            :label="military ? 'true' : 'false/null'"
                                        />
                                    </hb-form>

                                </span>

                                <hb-form label="status">
                                    <HbTextField
                                        v-model="status"
                                        placeholder="Enter Status"
                                    />
                                </hb-form>

                                <hb-form label="disableStatus">
                                    <HbSwitch
                                        v-model="disableStatus"
                                        :label="disableStatus ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="past-due-amount" v-if="type !== 'space'">
                                    <HbTextField
                                        v-model="pastDueAmount"
                                        placeholder="Enter Past Due Amount"
                                        :clearable="true"
                                    />
                                </hb-form>

                                <hb-form label="disableReport" v-if="type !== 'space'">
                                    <HbSwitch
                                        v-model="disableReport"
                                        :label="disableReport ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                            </hb-card>

                            <hb-card class="mt-6" title="Events">

                                <hb-form label="Last Emitted Event">
                                    {{ lastEmittedEvent }}<br />
                                    {{ fromComponent ? 'From: ' + fromComponent : '' }}
                                </hb-form>

                            </hb-card>

                        </v-col>

                    </v-row>
                
                </v-col>

                <v-col cols="4" class="pt-3">

                    <hb-card title="Props continued...">

                        <hb-form label="space-is-occupied" v-if="type === 'space'">
                            <HbSwitch
                                v-model="spaceIsOccupied"
                                :label="spaceIsOccupied ? 'true' : 'false/null'"
                            />
                        </hb-form>

                        <span v-if="(type === 'space' && spaceIsOccupied) || type !== 'space'">

                            <hb-form label="business-name">
                                <HbTextField
                                    v-model="businessName"
                                    placeholder="Enter Business Name"
                                    clearable
                                />
                            </hb-form>

                            <hb-form label="representative-name">
                                <HbTextField
                                    v-model="representativeName"
                                    placeholder="Enter Representative Name"
                                    clearable
                                />
                            </hb-form>

                            <hb-form label="tenant-name" v-if="type === 'space'">
                                <HbTextField
                                    v-model="tenantName"
                                    placeholder="Enter Tenant Name"
                                />
                            </hb-form>

                            <hb-form label="tenant-is-account" v-if="type === 'space'">
                                <HbSwitch
                                    v-model="tenantIsAccount"
                                    :label="tenantIsAccount ? 'true' : 'false/null'"
                                    :disabled="tenantIsBusiness"
                                />
                            </hb-form>

                            <hb-form label="tenant-is-business" v-if="type === 'space'">
                                <HbSwitch
                                    v-model="tenantIsBusiness"
                                    :label="tenantIsBusiness ? 'true' : 'false/null'"
                                    :disabled="tenantIsAccount"
                                />
                            </hb-form>

                            <hb-form label="phone">
                                <HbTextField
                                    v-model="phone"
                                    placeholder="Enter Phone"
                                />
                            </hb-form>

                            <hb-form label="allow-phone-click">
                                <HbSwitch
                                    v-model="allowPhoneClick"
                                    :label="allowPhoneClick ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <hb-form label="can-text">
                                <hb-radio-group v-model="canText">
                        
                                    <HbRadio
                                        label="true"
                                        :value="true"
                                    />

                                    <HbRadio
                                        label="false"
                                        :value="false"
                                    />

                                </hb-radio-group>

                                <hb-btn small @click="canText = null" :disabled="canText === null">Set to null</hb-btn>
                            </hb-form>

                            <hb-form label="email">
                                <HbTextField
                                    v-model="email"
                                    placeholder="Enter Email"
                                />
                            </hb-form>

                            <hb-form label="allow-email-click">
                                <HbSwitch
                                    v-model="allowEmailClick"
                                    :label="allowEmailClick ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <hb-form label="address">
                                <HbTextField
                                    v-model="address"
                                    placeholder="Enter Address"
                                />
                            </hb-form>

                        </span>

                        <span v-if="type === 'space'">

                            <hb-form label="space-type">
                                <HbSelect
                                    v-model="spaceType"
                                    :items="spaceTypes"
                                    item-text="type"
                                    item-value="type"
                                    placeholder="Select Space Type"
                                    :clearable="false"
                                />
                            </hb-form>

                            <hb-form label="space-category">
                                <HbTextField
                                    v-model="spaceCategory"
                                    placeholder="Enter Space Category"
                                />
                            </hb-form>

                            <hb-form label="space-featured-amenity">
                                <HbTextField
                                    v-model="spaceFeaturedAmenity"
                                    placeholder="Enter Space Featured Amenity"
                                />
                            </hb-form>

                            <hb-form label="space-property-info">
                                <HbTextField
                                    v-model="spacePropertyInfo"
                                    placeholder="Enter Space Property Info"
                                />
                            </hb-form>

                        </span>

                        <span v-if="type === 'contact' || type === 'business'">

                            <hb-form label="disable-contact-space-info" v-if="!isLead">
                                <HbSwitch
                                    v-model="disableContactSpaceInfo"
                                    :label="disableContactSpaceInfo ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <hb-form label="use-menu" v-if="!disableContactSpaceInfo && !isLead">
                                <HbSwitch
                                    v-model="useMenu"
                                    :label="useMenu ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <hb-form label="is-lead">
                                <HbSwitch
                                    v-model="isLead"
                                    :label="useMenu ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <span v-if="!useMenu && !disableContactSpaceInfo && !isLead">

                                <hb-form label="contact-space-type">
                                    <HbSelect
                                        v-model="contactSpaceType"
                                        :items="spaceTypes"
                                        item-text="type"
                                        item-value="type"
                                        placeholder="Select Contact Space Type"
                                        :clearable="false"
                                    />
                                </hb-form>

                                <hb-form label="contact-space-number">
                                    <HbTextField
                                        v-model="contactSpaceNumber"
                                        placeholder="Enter Contact Space Number"
                                    />
                                </hb-form>

                                <hb-form label="disable-contact-space-link">
                                    <HbSwitch
                                        v-model="disableContactSpaceLink"
                                        :label="disableContactSpaceLink ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="contact-space-category">
                                    <HbTextField
                                        v-model="contactSpaceCategory"
                                        placeholder="Enter Contact Space Category"
                                    />
                                </hb-form>

                                <hb-form label="contact-space-featured-amenity">
                                    <HbTextField
                                        v-model="contactSpaceFeaturedAmenity"
                                        placeholder="Enter Contact Space Featured Amenity"
                                    />
                                </hb-form>

                                <hb-form label="contact-space-property-info">
                                    <HbTextField
                                        v-model="contactSpacePropertyInfo"
                                        placeholder="Enter Contact Space Property Info"
                                    />
                                </hb-form>

                                <hb-form label="contact-space-access-code">
                                    <HbTextField
                                        v-model="contactSpaceAccessCode"
                                        placeholder="Enter Contact Space Access Code"
                                        clearable
                                    />
                                </hb-form>

                                <hb-form label="contact-space-lockout" v-if="contactSpaceAccessCode">
                                    <HbSwitch
                                        v-model="contactSpaceLockout"
                                        :label="contactSpaceLockout ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="disable-contact-space-access-click" v-if="contactSpaceAccessCode">
                                    <HbSwitch
                                        v-model="disableContactSpaceAccessClick"
                                        :label="disableContactSpaceAccessClick ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                            </span>

                            <span v-if="useMenu && !disableContactSpaceInfo && !isLead">

                                <hb-form label="menu-icon-type">
                                    <HbSelect
                                        v-model="menuIconType"
                                        :items="spaceTypes"
                                        item-text="type"
                                        item-value="type"
                                        placeholder="Enter Menu Icon Type"
                                        :clearable="false"
                                    />
                                </hb-form>

                                <hb-form label="contact-space-count">
                                    <HbSelect
                                        v-model="contactSpaceCount"
                                        :items="numberCount"
                                        placeholder="Enter Contact Space Count"
                                        clearable
                                    />
                                </hb-form>

                                <hb-form label="contact-space-count-other-properties">
                                    <HbSelect
                                        v-model="contactSpaceCountOtherProperties"
                                        :items="numberCount"
                                        placeholder="Enter Contact Space Count Other Properties"
                                        clearable
                                    />
                                </hb-form>

                                <hb-form label="contact-active-lead-count">
                                    <HbSelect
                                        v-model="contactActiveLeadCount"
                                        :items="numberCount"
                                        placeholder="Enter Contact Active Lead Count"
                                        clearable
                                    />
                                </hb-form>

                            </span>

                        </span>

                        <span v-if="type === 'lead' || ((type === 'contact' || type === 'business') && isLead)">

                            <hb-form label="disable-lead-info">
                                <HbSwitch
                                    v-model="disableLeadInfo"
                                    :label="disableLeadInfo ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <span v-if="!disableLeadInfo">

                                <hb-form label="lead-type">
                                    <HbTextField
                                        v-model="leadType"
                                        placeholder="Enter Lead Type"
                                    />
                                </hb-form>

                                <hb-form label="disable-lead-link">
                                    <HbSwitch
                                        v-model="disableLeadLink"
                                        :label="disableLeadLink ? 'true' : 'false/null'"
                                    />
                                </hb-form>

                                <hb-form label="lead-space-type">
                                    <HbSelect
                                        v-model="leadSpaceType"
                                        :items="spaceTypes"
                                        item-text="type"
                                        item-value="type"
                                        placeholder="Select Lead Space Type"
                                        :clearable="false"
                                    />
                                </hb-form>
                                
                                <hb-form label="lead-space-number">
                                    <HbTextField
                                        v-model="leadSpaceNumber"
                                        placeholder="Enter Lead Space Number"
                                    />
                                </hb-form>

                                <hb-form label="lead-space-category">
                                    <HbTextField
                                        v-model="leadSpaceCategory"
                                        placeholder="Enter Lead Space Category"
                                    />
                                </hb-form>

                                <hb-form label="lead-featured-amenity">
                                    <HbTextField
                                        v-model="leadFeaturedAmenity"
                                        placeholder="Enter Lead Featured Amenity"
                                    />
                                </hb-form>

                                <hb-form label="lead-property-info">
                                    <HbTextField
                                        v-model="leadPropertyInfo"
                                        placeholder="Enter Lead Property Info"
                                    />
                                </hb-form>

                            </span>

                        </span>

                        <span v-if="type === 'account'">

                            <hb-form label="disable-account-info">
                                <HbSwitch
                                    v-model="disableAccountInfo"
                                    :label="disableAccountInfo ? 'true' : 'false/null'"
                                />
                            </hb-form>

                            <span v-if="!disableAccountInfo">

                                <hb-form label="account-space-type">
                                    <HbSelect
                                        v-model="accountSpaceType"
                                        :items="spaceTypes"
                                        item-text="type"
                                        item-value="type"
                                        placeholder="Select Account Space Type"
                                        :clearable="false"
                                    />
                                </hb-form>

                                <hb-form label="account-space-count">
                                    <HbSelect
                                        v-model="accountSpaceCount"
                                        :items="numberCount"
                                        placeholder="Select Account Space Count"
                                        :clearable="false"
                                    />
                                </hb-form>

                                <hb-form label="account-size">
                                    <HbTextField
                                        v-model="accountSize"
                                        placeholder="Enter Account Size"
                                    />
                                </hb-form>

                                <hb-form label="account-total-monthly-spent">
                                    <HbTextField
                                        v-model="accountTotalMonthlySpent"
                                        placeholder="Enter Account Total Monthly Spent"
                                    />
                                </hb-form>

                            </span>

                        </span>

                    </hb-card>

                    <hb-card class="mt-6" title="Slots">
                        <hb-form label="reportTooltipBody" :tooltip-body="disableReport ? 'Report is disabled via disable-report prop' : type === 'space' ? 'Space Type cannot use the report feature' : null">
                            <HbTextarea
                                v-model="reportTooltipBody"
                                :rows="4"
                                placeholder="Total Balance: $234.00<br />Lifetime Value: $5645.00<br />Lifetime Credit: $765.00<br />Prepaid Balance: $0.00"
                                :disabled="disableReport || type === 'space'"
                            />
                        </hb-form>

                        <hb-form label="menuSpaces" full v-if="(type === 'contact' || type === 'business') && useMenu">
                            See example code for a sample usage
                        </hb-form>

                        <hb-form label="menuSpacesOtherProperties" v-if="(type === 'contact' || type === 'business') && useMenu">
                            See example code for a sample usage
                        </hb-form>

                        <hb-form label="menuActiveLeads" v-if="(type === 'contact' || type === 'business') && useMenu">
                            See example code for a sample usage
                        </hb-form>
                    </hb-card>
                </v-col>
            </v-row>
        </div>

        <div v-if="activeTab === 1">

            <hb-card title="Contact Type Example used with HbHeader &amp; Right Side Action + Code" class="mt-6 mb-6">
                <div class="mb-4 mx-6">
                    <hb-header one-action>
                        <template v-slot:left>
                            <hb-mini-profile
                                type="contact"
                                thumbnail="https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                                id-verified
                                title="Harry Potter"
                                military
                                status="current"
                                phone="+1 (310) 234-2354"
                                email="harrypotter@hogwarts.com"
                                address="100 Horcrux Street, Hogwarts 90039"
                                contact-space-type="storage"
                                contact-space-number="100"
                                contact-space-category="10' x 10'"
                                contact-space-featured-amenity="Climate Controlled"
                                contact-space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                contact-space-access-code="12345"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                                @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                                @contact-space-click="handleEmittedClickEvent('@contact-space-click', 'HbMiniProfile')"
                                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfile')"
                            >
                                <template v-slot:reportTooltipBody>
                                    Total Balance: $234.00<br />
                                    Lifetime Value: $5645.00<br />
                                    Lifetime Credit: $765.00<br />
                                    Prepaid Balance: $0.00
                                </template>
                            </hb-mini-profile>
                        </template>
                        <template v-slot:right>
                            <HbBtn
                                class="ml-1"
                                icon
                                tooltip="Open Menu"
                                mdi-code="mdi-table-actions-custom-1"
                            />
                        </template>
                    </hb-header>
                </div>

            <hb-card class="pa-6" color="#E0F5F5" no-title>
<pre class="px-4" :style="codeExpanded1 ? 'height:auto' : 'height:230px;'">
    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="codeExpanded1 = !codeExpanded1">
        {{ codeExpanded1 ? 'Collapse Code' : 'Expand Code' }}
        <HbIcon class="pl-1" :mdi-code="codeExpanded1 ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </div>
&lt;hb-header one-action>
    &lt;template v-slot:left>
        &lt;hb-mini-profile
            type="contact"
            thumbnail="https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            id-verified
            title="Harry Potter"
            military
            status="current"
            phone="+1 (310) 234-2354"
            email="harrypotter@hogwarts.com"
            address="100 Horcrux Street, Hogwarts 90039"
            contact-space-type="storage"
            contact-space-number="100"
            contact-space-category="10' x 10'"
            contact-space-featured-amenity="Climate Controlled"
            contact-space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            contact-space-access-code="12345"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
            @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
            @contact-space-click="handleEmittedClickEvent('@contact-space-click', 'HbMiniProfile')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfile')"
        >
            &lt;template v-slot:reportTooltipBody>
                Total Balance: $234.00&lt;br />
                Lifetime Value: $5645.00&lt;br />
                Lifetime Credit: $765.00&lt;br />
                Prepaid Balance: $0.00
            &lt;/template>
        &lt;/hb-mini-profile>
    &lt;/template>
    &lt;template v-slot:right>
        &lt;HbBtn
            class="ml-1"
            icon
            tooltip="Open Menu"
            mdi-code="mdi-table-actions-custom-1"
        />
    &lt;/template>
&lt;/hb-header>
</pre>
                </hb-card>
            </hb-card>

            <hb-card title="Business Type Example + Code" class="mt-4 mb-6">
                <div class="my-4 mx-6">
                    <hb-mini-profile
                        type="business"
                        title="Hogwarts Academy"
                        do-not-rent
                        bankrupt
                        military
                        status="active lien"
                        past-due-amount="$100"
                        representative-name="Harry Potter"
                        phone="+1 (310) 234-2354"
                        email="harrypotter@hogwarts.com"
                        address="100 Horcrux Street, Hogwarts 90039"
                        use-menu
                        :contactSpaceCount="2"
                        :contactSpaceCountOtherProperties="2"
                        :contactActiveLeadCount="2"
                        @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                        @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                    >
                        <template v-slot:reportTooltipBody>
                            Total Balance: $234.00<br />
                            Lifetime Value: $5645.00<br />
                            Lifetime Credit: $765.00<br />
                            Prepaid Balance: $0.00
                        </template>

                        <template v-slot:menuSpaces>

                            <HbMiniProfileItem
                                type="space"
                                space-type="storage"
                                space-number="100"
                                space-category="10' x 10'"
                                space-featured-amenity="Climate Controlled"
                                space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                space-access-code="12345"
                                space-status="Current"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
                                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                            />

                            <HbMiniProfileItem
                                type="space"
                                space-type="storage"
                                space-number="101"
                                space-category="10' x 10'"
                                space-featured-amenity="Climate Controlled"
                                space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                space-access-code="23451"
                                space-lockout
                                space-status="Active Lien"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
                                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                            />
                        </template>

                        <template v-slot:menuSpacesOtherProperties>

                            <HbMiniProfileItem
                                type="space"
                                space-type="storage"
                                space-number="200"
                                space-category="10' x 10'"
                                space-featured-amenity="Climate Controlled"
                                space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
                                space-access-code="34512"
                                space-status="Current"
                                disable-space-link
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                            />

                            <HbMiniProfileItem
                                type="space"
                                space-type="parking"
                                space-number="201"
                                space-category="10' x 10'"
                                space-featured-amenity="Climate Controlled"
                                space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
                                space-access-code="45231"
                                space-lockout
                                space-status="Active Lien"
                                disable-space-link
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
                            />

                        </template>

                        <template v-slot:menuActiveLeads>

                            <HbMiniProfileItem
                                type="lead"
                                lead-type="Reservation"
                                lead-space-type="storage"
                                lead-space-category="10' x 10'"
                                lead-featured-amenity="Climate Controlled"
                                lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
                            />

                            <HbMiniProfileItem
                                type="lead"
                                lead-type="Reservation"
                                lead-space-type="parking"
                                lead-space-category="10' x 10'"
                                lead-featured-amenity="Elevator Access"
                                lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
                                @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
                            />

                        </template>

                        <template v-slot:menuClosedLeases>

                            <HbMiniProfileItem
                                type="closed"
                                closed-space-type="storage"
                                :closed-count="5"
                                closed-status="Balance Due"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem', 'HbMiniProfileItem')"
                            />

                        </template>
                        
                    </hb-mini-profile>
                </div>

            <hb-card class="pa-6" color="#E0F5F5" no-title>
<pre class="px-4" :style="codeExpanded2 ? 'height:auto' : 'height:230px;'">
    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="codeExpanded2 = !codeExpanded2">
        {{ codeExpanded2 ? 'Collapse Code' : 'Expand Code' }}
        <HbIcon class="pl-1" :mdi-code="codeExpanded2 ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </div>
&lt;hb-mini-profile
    type="business"
    title="Hogwarts Academy"
    do-not-rent
    bankrupt
    military
    status="active lien"
    past-due-amount="$100"
    representative-name="Harry Potter"
    phone="+1 (310) 234-2354"
    email="harrypotter@hogwarts.com"
    address="100 Horcrux Street, Hogwarts 90039"
    use-menu
    :contactSpaceCount="2"
    :contactSpaceCountOtherProperties="2"
    :contactActiveLeadCount="2"
    @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
    @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
>
    &lt;template v-slot:reportTooltipBody>
        Total Balance: $234.00&lt;br />
        Lifetime Value: $5645.00&lt;br />
        Lifetime Credit: $765.00&lt;br />
        Prepaid Balance: $0.00
    &lt;/template>

    &lt;template v-slot:menuSpaces>

        &lt;HbMiniProfileItem
            type="space"
            space-type="storage"
            space-number="100"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            space-access-code="12345"
            space-status="Current"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />

        &lt;HbMiniProfileItem
            type="space"
            space-type="storage"
            space-number="101"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            space-access-code="23451"
            space-lockout
            space-status="Active Lien"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @space-click="handleEmittedClickEvent('@space-click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />
    &lt;/template>

    &lt;template v-slot:menuSpacesOtherProperties>

        &lt;HbMiniProfileItem
            type="space"
            space-type="storage"
            space-number="200"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
            space-access-code="34512"
            space-status="Current"
            disable-space-link
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />

        &lt;HbMiniProfileItem
            type="space"
            space-type="parking"
            space-number="201"
            space-category="10' x 10'"
            space-featured-amenity="Climate Controlled"
            space-property-info="SS124 - Grindlewald - 23 Expecto Drive"
            space-access-code="45231"
            space-lockout
            space-status="Active Lien"
            disable-space-link
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfileItem')"
        />

    &lt;/template>

    &lt;template v-slot:menuActiveLeads>

        &lt;HbMiniProfileItem
            type="lead"
            lead-type="Reservation"
            lead-space-type="storage"
            lead-space-category="10' x 10'"
            lead-featured-amenity="Climate Controlled"
            lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
        />

        &lt;HbMiniProfileItem
            type="lead"
            lead-type="Reservation"
            lead-space-type="parking"
            lead-space-category="10' x 10'"
            lead-featured-amenity="Elevator Access"
            lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem')"
            @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfileItem')"
        />

    &lt;/template>

    &lt;template v-slot:menuClosedLeases>

        &lt;HbMiniProfileItem
            type="closed"
            closed-space-type="storage"
            :closed-count="5"
            closed-status="Balance Due"
            @click="handleEmittedClickEvent('@click', 'HbMiniProfileItem', 'HbMiniProfileItem')"
        />

    &lt;/template>

&lt;/hb-mini-profile>
</pre>
                </hb-card>
            </hb-card>

            <hb-card title="Space Type Example + Code" class="mt-4 mb-6">
                <div class="my-4 mx-6 mt-4">
                    <HbMiniProfile
                        type="space"
                        status="leased"
                        title="100"
                        space-is-occupied
                        tenant-name="Harry Potter"
                        phone="+1 (310) 234-2354"
                        email="harrypotter@hogwarts.com"
                        address="100 Horcrux Street, Hogwarts 90039"
                        space-type="storage"
                        space-category="10' x 10'"
                        space-featured-amenity="Climate Controlled"
                        space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                        @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                        @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                    />
                </div>

                <hb-card class="pa-6" color="#E0F5F5" no-title>
<pre class="px-4" :style="codeExpanded3 ? 'height:auto' : 'height:230px;'">
    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="codeExpanded3 = !codeExpanded3">
        {{ codeExpanded3 ? 'Collapse Code' : 'Expand Code' }}
        <HbIcon class="pl-1" :mdi-code="codeExpanded3 ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </div>
&lt;HbMiniProfile
    type="space"
    status="leased"
    title="100"
    space-is-occupied
    tenant-name="Harry Potter"
    phone="+1 (310) 234-2354"
    email="harrypotter@hogwarts.com"
    address="100 Horcrux Street, Hogwarts 90039"
    space-type="storage"
    space-category="10' x 10'"
    space-featured-amenity="Climate Controlled"
    space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
    @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
    @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
/>
</pre>
                </hb-card>
            </hb-card>

            <hb-card title="Lead Type Example + Code" class="mt-4 mb-6">
                <div class="my-4 mx-6 mt-4">
                    <HbMiniProfile
                        type="lead"
                        title="Harry Potter"
                        do-not-rent
                        status="active lead"
                        phone="+1 (310) 234-2354"
                        email="harrypotter@hogwarts.com"
                        address="100 Horcrux Street, Hogwarts 90039"
                        lead-type="Reservation"
                        lead-space-type="car_wash"
                        lead-space-number="99"
                        lead-space-category="11' x 11'"
                        lead-featured-amenity="Climate Controlled"
                        lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                        @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                        @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                        @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfile')"
                    />
                </div>

                <hb-card class="pa-6" color="#E0F5F5" no-title>
<pre class="px-4" :style="codeExpanded4 ? 'height:auto' : 'height:230px;'">
    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="codeExpanded4 = !codeExpanded4">
        {{ codeExpanded4 ? 'Collapse Code' : 'Expand Code' }}
        <HbIcon class="pl-1" :mdi-code="codeExpanded4 ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </div>
&lt;HbMiniProfile
    type="lead"
    title="Harry Potter"
    do-not-rent
    status="active lead"
    phone="+1 (310) 234-2354"
    email="harrypotter@hogwarts.com"
    address="100 Horcrux Street, Hogwarts 90039"
    lead-type="Reservation"
    lead-space-number="99"
    lead-space-type="car_wash"
    lead-space-category="11' x 11'"
    lead-featured-amenity="Climate Controlled"
    lead-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
    @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
    @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
    @lead-click="handleEmittedClickEvent('@lead-click', 'HbMiniProfile')"
/>
</pre>
                </hb-card>
            </hb-card>

            <hb-card title="Account Type Example + Code" class="mt-4 mb-6">
                <div class="my-4 mx-6 mt-4">
                    <hb-mini-profile
                        type="account"
                        title="Hogwarts Account"
                        status="current"
                        businessName="Hogwarts Academy"
                        representativeName="Harry Potter"
                        phone="+1 (310) 234-2354"
                        email="harrypotter@hogwarts.com"
                        address="100 Horcrux Street, Hogwarts 90039"
                        account-space-type="storage"
                        :account-space-count="40"
                        account-size="1,200 sqm"
                        account-total-monthly-spent="$532"
                        @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                        @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                    >
                        <template v-slot:reportTooltipBody>
                            Total Balance: $234.00<br />
                            Lifetime Value: $5645.00<br />
                            Lifetime Credit: $765.00<br />
                            Prepaid Balance: $0.00
                        </template>
                    </hb-mini-profile>
                </div>

                <hb-card class="pa-6" color="#E0F5F5" no-title>
<pre class="px-4" :style="codeExpanded5 ? 'height:auto' : 'height:230px;'">
    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="codeExpanded5 = !codeExpanded5">
        {{ codeExpanded5 ? 'Collapse Code' : 'Expand Code' }}
        <HbIcon class="pl-1" :mdi-code="codeExpanded5 ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </div>
&lt;hb-mini-profile
    type="account"
    title="Hogwarts Account"
    status="current"
    businessName="Hogwarts Academy"
    representativeName="Harry Potter"
    phone="+1 (310) 234-2354"
    email="harrypotter@hogwarts.com"
    address="100 Horcrux Street, Hogwarts 90039"
    account-space-type="storage"
    :account-space-count="40"
    account-size="1,200 sqm"
    account-total-monthly-spent="$532"
    @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
    @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
>
    &lt;template v-slot:reportTooltipBody>
        Total Balance: $234.00&lt;br />
        Lifetime Value: $5645.00&lt;br />
        Lifetime Credit: $765.00&lt;br />
        Prepaid Balance: $0.00
    &lt;/template>
&lt;/hb-mini-profile>
</pre>
                </hb-card>
            </hb-card>

            <hb-card title="Background Color Match Examples via @emitType" class="mt-4 mb-6">
                <div
                    class="mb-4"
                    v-for="n in 5"
                    :key="'bg' + n"
                    :class="bg[n] === 'success' ? 'hb-success-shade' : bg[n] === 'caution' ? 'hb-caution-shade' : bg[n] === 'error' ? 'hb-error-shade' : bg[n] === 'guidance' ? 'hb-guidance-shade' : ''"
                >
                    <hb-header>
                        <template v-slot:left>
                            <hb-mini-profile
                                class="px-6"
                                type="contact"
                                thumbnail="https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                                id-verified
                                title="Harry Potter"
                                military
                                :status="n === 1 ? 'current' : n === 2 ? 'active lead' : n === 3 ? 'active lien' : n === 4 ? 'leased' : 'lease closed'"
                                phone="+1 (310) 234-2354"
                                email="harrypotter@hogwarts.com"
                                address="100 Horcrux Street, Hogwarts 90039"
                                contact-space-type="storage"
                                contact-space-number="100"
                                contact-space-category="10' x 10'"
                                contact-space-featured-amenity="Climate Controlled"
                                contact-space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                                contact-space-access-code="12345"
                                @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                                @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                                @contact-space-click="handleEmittedClickEvent('@contact-space-click', 'HbMiniProfile')"
                                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfile')"
                                @emitType="bg[n] = $event"
                            >
                                <template v-slot:reportTooltipBody>
                                    Total Balance: $234.00<br />
                                    Lifetime Value: $5645.00<br />
                                    Lifetime Credit: $765.00<br />
                                    Prepaid Balance: $0.00
                                </template>
                            </hb-mini-profile>
                        </template>
                    </hb-header>
                </div>

            <hb-card class="pa-6" color="#E0F5F5" no-title>
<pre class="px-4" :style="codeExpanded6 ? 'height:auto' : 'height:230px;'">
    <div style="position:absolute;top:-4px;right:12px;" class="d-flex align-center hb-pointer" @click="codeExpanded6 = !codeExpanded6">
        {{ codeExpanded6 ? 'Collapse Code' : 'Expand Code' }}
        <HbIcon class="pl-1" :mdi-code="codeExpanded6 ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
    </div>
&lt;div
    class="mb-4"
    v-for="n in 5"
    :key="'bg' + n"
    :class="bg[n] === 'success' ? 'hb-success-shade' : bg[n] === 'caution' ? 'hb-caution-shade' : bg[n] === 'error' ? 'hb-error-shade' : bg[n] === 'guidance' ? 'hb-guidance-shade' : ''"
>
    &lt;hb-header>
        &lt;template v-slot:left>
            &lt;hb-mini-profile
                class="px-6"
                type="contact"
                thumbnail="https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                id-verified
                title="Harry Potter"
                military
                :status="n === 1 ? 'current' : n === 2 ? 'active lead' : n === 3 ? 'active lien' : n === 4 ? 'leased' : 'lease closed'"
                phone="+1 (310) 234-2354"
                email="harrypotter@hogwarts.com"
                address="100 Horcrux Street, Hogwarts 90039"
                contact-space-type="storage"
                contact-space-number="100"
                contact-space-category="10' x 10'"
                contact-space-featured-amenity="Climate Controlled"
                contact-space-property-info="SS123 - Hogwarts - 1234 Patrona Lane"
                contact-space-access-code="12345"
                @click="handleEmittedClickEvent('@click', 'HbMiniProfile')"
                @avatar-click="handleEmittedClickEvent('@avatar-click', 'HbMiniProfile')"
                @contact-space-click="handleEmittedClickEvent('@contact-space-click', 'HbMiniProfile')"
                @access-click="handleEmittedClickEvent('@access-click', 'HbMiniProfile')"
                @emitType="bg[n] = $event"
            >
                &lt;template v-slot:reportTooltipBody>
                    Total Balance: $234.00&lt;br />
                    Lifetime Value: $5645.00&lt;br />
                    Lifetime Credit: $765.00&lt;br />
                    Prepaid Balance: $0.00
                &lt;/template>
            &lt;/hb-mini-profile>
        &lt;/template>
    &lt;/hb-header>
&lt;/div>
</pre>
                </hb-card>
            </hb-card>

        </div>

        <hb-card title="HbMiniProfile Props" class="my-6 pb-1">
            <hb-data-table
                :headers="propHeaders"
                :items="propItems"
                class="pa-6"
            >
            </hb-data-table>
        </hb-card>

        <hb-card title="HbMiniProfile Slots" class="my-6 pb-1">
            <hb-data-table
                :headers="slotHeaders"
                :items="slotItems"
                class="pa-6"
            >
            </hb-data-table>
        </hb-card>

        <hb-card title="HbMiniProfile Events" class="my-6 pb-1">
            <hb-data-table
                :headers="eventHeaders"
                :items="eventItems"
                class="pa-6"
            >
            </hb-data-table>
        </hb-card>

        <hb-card title="HbMiniProfileItem Props" class="my-6 pb-1">
            <hb-data-table
                :headers="itemPropHeaders"
                :items="itemPropItems"
                class="pa-6"
            >
            </hb-data-table>
        </hb-card>

        <hb-card title="HbMiniProfileItem Events" class="my-6 pb-1">
            <hb-data-table
                :headers="itemEventHeaders"
                :items="itemEventItems"
                class="pa-6"
            >
            </hb-data-table>
        </hb-card>

        <hb-global-notification
            v-model="success"
            type="success"
            :description="description"
        >
        </hb-global-notification>

    </div>

</template>
<script type="text/babel">

    import tokens from '../../aviary/tokens.js';

    export default {
        name: "DesignSystemMiniProfile",
        data: function() {
            return {
                activeTab: '',
                prototypeCodeExpanded: false,
                type: 'contact',
                disableClick: false,
                thumbnail: 'https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
                disableThumbnail: false,
                doNotRent: true,
                idVerified: true,
                disableAvatarClick: false,
                title: 'Harry Potter',
                bankrupt: true,
                military: true,
                status: 'current',
                disableStatus: false,
                pastDueAmount: '$100',
                disableReport: false,
                businessName: '',
                representativeName: '',
                phone: '+1 (310) 234-2354',
                allowPhoneClick: false,
                canText: null,
                email: 'harrypotter@hogwarts.com',
                allowEmailClick: false,
                address: '100 Horcrux Street, Hogwarts 90039',
                spaceIsOccupied: true,
                tenantName: 'Harry Potter',
                tenantIsAccount: false,
                tenantIsBusiness: false,
                spaceType: 'storage',
                spaceCategory: "10' x 10'",
                spaceFeaturedAmenity: 'Climate Controlled',
                spacePropertyInfo: 'SS123 - Hogwarts - 1234 Patrona Lane',
                contactSpaceType: 'storage',
                contactSpaceNumber: '100',
                disableContactSpaceLink: false,
                contactSpaceCategory: "10' x 10'",
                contactSpaceFeaturedAmenity: 'Climate Controlled',
                contactSpacePropertyInfo: 'SS123 - Hogwarts - 1234 Patrona Lane',
                contactSpaceAccessCode: '12345',
                contactSpaceLockout: false,
                disableContactSpaceAccessClick: false,
                disableContactSpaceInfo: false,
                useMenu: false,
                menuIconType: 'storage',
                contactSpaceCount: 2,
                contactSpaceCountOtherProperties: 2,
                contactActiveLeadCount: 2,
                isLead: false,
                leadType: 'Reservation',
                disableLeadLink: false,
                leadSpaceType: 'car_wash',
                leadSpaceNumber: "100",
                leadSpaceCategory: "11' x 11'",
                leadFeaturedAmenity: 'Climate Controlled',
                leadPropertyInfo: 'SS123 - Hogwarts - 1234 Patrona Lane',
                disableLeadInfo: false,
                accountSpaceType: 'storage',
                accountSpaceCount: 40,
                accountSize: '1,200 sqm',
                accountTotalMonthlySpent: '$532',
                disableAccountInfo: false,

                reportTooltipBody: 'Total Balance: $234.00<br />Lifetime Value: $5645.00<br />Lifetime Credit: $765.00<br />Prepaid Balance: $0.00',
                types: [ 'contact', 'business', 'space', 'lead', 'account' ],
                spaceTypes: tokens.icons.spaces,
                numberCount: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50, 60, 70, 80, 90, 99, 100, 200],
                lastEmittedEvent: '',
                fromComponent: '',

                codeExpanded1: false,
                codeExpanded2: false,
                codeExpanded3: false,
                codeExpanded4: false,
                codeExpanded5: false,
                codeExpanded6: false,
                bg: {
                    1: '',
                    2: '',
                    3: '',
                    4: '',
                    5: ''
                },
                success: false,
                description: '',
                propHeaders: [
                    { text: 'Name', value: 'name', width: '125' },
                    { text: 'Type', value: 'type' },
                    { text: 'Default', value: 'default', width: '100' },
                    { text: 'Description', value: 'description' },
                ],
                propItems: [
                    { name: 'type', type: 'string', default: 'undefined', description: 'Sets the type of the avatar icon and the type of info and props displayed. Possible options are "contact", "lead", "business", "account", and "space".' },
                    { name: 'disable-click', type: 'boolean', default: 'false', description: 'Set to true to disable the main click event.' },
                    { name: 'thumbnail', type: 'string', default: 'undefined', description: 'Sets the avatar as a thumbnail image. Place the url of the image you want to display into this prop.' },
                    { name: 'disable-thumbnail', type: 'boolean', default: 'false', description: 'Set to true to turn off the thumbnail image and show the default icons instead.' },
                    { name: 'id-verified', type: 'boolean', default: 'false', description: 'Set to true to display the id verified checkmark and blue border around the avatar.' },
                    { name: 'disable-avatar-click', type: 'boolean', default: 'false', description: 'Set to true to disable the "avatar-click" event when the avatar is clicked.' },
                    { name: 'title', type: 'string', default: 'undefined', description: 'Sets the title text. Here is where you will place either the contact name, lead name, business name, account name, or space number depending on the "type" you are using.' },
                    { name: 'do-not-rent', type: 'boolean', default: 'false', description: 'Set to true to display the "Do Not Rent" icon.' },
                    { name: 'bankrupt', type: 'boolean', default: 'false', description: 'Set to true to display the "Bankrupt" icon. Does not work for "space" type.' },
                    { name: 'military', type: 'boolean', default: 'false', description: 'Set to true to display the "Military" icon. Does not work for "space" type.' },
                    { name: 'status', type: 'string', default: 'undefined', description: 'Sets the status chip text. Color will be set automatically by the text string used.' },
                    { name: 'disable-status', type: 'boolean', default: 'false', description: 'Set to true to turn off the display of the status chip.' },
                    { name: 'past-due-amount', type: 'string', default: 'undefined', description: 'Sets the past due amount for display.' },
                    { name: 'disable-report', type: 'boolean', default: 'false', description: 'Set to true to turn off the display of the report icon and tooltip and past due amount.' },
                    { name: 'business-name', type: 'string', default: 'undefined', description: 'Sets the business name in any view. You can also use "tenant-is-business" prop and "tenant-name" prop instead to set this in "space" type view only.' },
                    { name: 'representative-name', type: 'string', default: 'undefined', description: 'Sets the representative name.' },
                    { name: 'phone', type: 'string', default: 'undefined', description: 'Sets the phone number displayed.' },
                    { name: 'allow-phone-click', type: 'boolean', default: 'false', description: 'Set to true to make the phone number clickable and bolded blue. When clicked, the phone number will activate a dropdown menu with two options with emit events when clicked ("phone-call-click" and "phone-text-click"). This should only be set to true for Charm enabled customers.' },
                    { name: 'can-text', type: 'boolean', default: 'null', description: 'Set to true to show the can text icon. Set to false to show the cannot text icon. Leave as null to show no icon.' },
                    { name: 'email', type: 'string', default: 'undefined', description: 'Sets the email address displayed.' },
                    { name: 'allow-email-click', type: 'boolean', default: 'false', description: 'Set to true to make the email clickable and bolded blue. When clicked, the event "email-click" will be emitted. This should only be set to true for Charm enabled customers.' },
                    { name: 'address', type: 'string', default: 'undefined', description: 'Sets the address text displayed.' },
                    { name: 'space-is-occupied', type: 'boolean', default: 'false', description: 'Set to true to show tenant information row for "space" type usages.' },
                    { name: 'tenant-name', type: 'string', default: 'undefined', description: 'Sets the tenant name for "space" type usages.' },
                    { name: 'tenant-is-account', type: 'boolean', default: 'false', description: 'Set to true to show national account icon in front of the tenant name for "space" type usages.' },
                    { name: 'tenant-is-business', type: 'boolean', default: 'false', description: 'Set to true to show business icon in front of the tenant name for "space" type usages.' },
                    { name: 'space-type', type: 'string', default: 'undefined', description: 'Sets the space type to show the appropriate icons in the avatar and in the rows when using "space" type. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'space-category', type: 'string', default: 'undefined', description: 'Sets the space category text for "space" type usages.' },
                    { name: 'space-featured-amenity', type: 'string', default: 'undefined', description: 'Sets the space featured amenity text for "space" type usages.' },
                    { name: 'space-property-info', type: 'string', default: 'undefined', description: 'Sets the space property info text for "space" type usages.' },
                    { name: 'contact-space-type', type: 'string', default: 'undefined', description: 'Sets the space type to show the appropriate icons in the single occupied space row information when using "contact" type or "business" type. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'contact-space-number', type: 'string', default: 'undefined', description: 'Sets the space number for the single occupied space row information when using "contact" type or "business" type.' },
                    { name: 'disable-contact-space-link', type: 'boolean', default: 'false', description: 'Set to true to disable the link and disable the blue color of the single occupied space icon and number when using "contact" type or "business" type.' },
                    { name: 'contact-space-category', type: 'string', default: 'undefined', description: 'Sets the space category for the single occupied space row information when using "contact" type or "business" type.' },
                    { name: 'contact-space-featured-amenity', type: 'string', default: 'undefined', description: 'Sets the space featured amenity for the single occupied space row information when using "contact" type or "business" type.' },
                    { name: 'contact-space-property-info', type: 'string', default: 'undefined', description: 'Sets the space property info text for the single occupied space row information when using "contact" type or "business" type.' },
                    { name: 'contact-space-access-code', type: 'string', default: 'undefined', description: 'Sets the space access code number text for the single occupied space row information when using "contact" type or "business" type.' },
                    { name: 'contact-space-lockout', type: 'boolean', default: 'false', description: 'Set to true to turn the space access code icon to red with a slash through it for the single occupied space row information when using "contact" type or "business" type.' },
                    { name: 'disable-contact-space-access-click', type: 'boolean', default: 'false', description: 'Set to true disable the "access-click" event when the contact space access code is clicked and turn off the hand pointer.' },
                    { name: 'disable-contact-space-info', type: 'boolean', default: 'false', description: 'Set to true disable the single occupied space information row when using "contact" type or "business" type.' },
                    { name: 'use-menu', type: 'boolean', default: 'false', description: 'Set to true use the dropdown menu instead of the single occupied space row. Populate the dispaly text and menu with props and slots as described further below and in the documentation examples.' },
                    { name: 'menu-icon-type', type: 'string', default: 'storage', description: 'When the "use-menu" prop is set to true, sets the left side menu icon. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'contact-space-count', type: 'number', default: '0', description: 'When the "use-menu" prop is set to true, set the number count of the occupied spaces at the current selected properties here.' },
                    { name: 'contact-space-count-other-properties', type: 'number', default: '0', description: 'When the "use-menu" prop is set to true, set the number count of the occupied spaces at other properties here.' },
                    { name: 'contact-active-lead-count', type: 'number', default: '0', description: 'When the "use-menu" prop is set to true, set the number count of the active leads here.' },
                    { name: 'is-lead', type: 'boolean', default: 'false', description: 'You can either set "type" to "lead" for leads or set "type" to "contact" or "business" and also set "is-lead" to true to show the lead information row. It is here for flexibility. Probably better to just set the "type" to "lead" for leads.' },
                    { name: 'lead-type', type: 'string', default: 'undefined', description: 'Sets the lead type text when using "lead" type or "is-lead" prop.' },
                    { name: 'disable-lead-link', type: 'boolean', default: 'false', description: 'Set to true to disable the link and disable the blue color of the lead type text when using "lead" type or "is-lead" prop.' },
                    { name: 'lead-space-type', type: 'string', default: 'undefined', description: 'Sets the lead space type to show the appropriate icons in the lead space information row when using "lead" type or "is-lead" prop. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'lead-space-number', type: 'string', default: 'undefined', description: 'Sets the lead space number to show when using "lead" type or "is-lead" prop.' },
                    { name: 'lead-space-category', type: 'string', default: 'undefined', description: 'Sets the lead space category text when using "lead" type or "is-lead" prop.' },
                    { name: 'lead-featured-amenity', type: 'string', default: 'undefined', description: 'Sets the lead space featured amenity text when using "lead" type or "is-lead" prop.' },
                    { name: 'lead-property-info', type: 'string', default: 'undefined', description: 'Sets the lead space property info text when using "lead" type or "is-lead" prop.' },
                    { name: 'disable-lead-info', type: 'boolean', default: 'false', description: 'Set to true disable the lead space information row when using "lead" type or "is-lead" prop.' },
                    { name: 'account-space-type', type: 'string', default: 'undefined', description: 'Sets the account space type to show the appropriate icons in the account information row when using "account" type. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'account-space-count', type: 'number', default: '0', description: 'Sets the account space count to show when using "account" type.' },
                    { name: 'account-size', type: 'string', default: 'undefined', description: 'Sets the account size text to display when using "account" type.' },
                    { name: 'account-total-monthly-spent', type: 'string', default: 'undefined', description: 'Sets the account total monthly spent text to display when using "account" type.' },
                    { name: 'disable-account-info', type: 'boolean', default: 'false', description: 'Set to true disable the account information row when using "account" type.' },
                ],
                slotHeaders: [
                    { text: 'Name', value: 'name' },
                    { text: 'Description', value: 'description' },
                ],
                slotItems: [
                    { name: 'reportTooltipBody', description: 'Sets the text to display in the tooltip when the report icon is hovered over.' },
                    { name: 'menuSpaces', description: 'When "use-menu" prop is set to true, sets the items to display in the dropdown menu content for spaces at the properties selected. Here is where you will usually loop through items using HbMiniProfileItem. ' },
                    { name: 'menuSpacesOtherProperties', description: 'When "use-menu" prop is set to true, sets the items to display in the dropdown menu content for spaces at other properties. Here is where you will usually loop through items using HbMiniProfileItem. ' },
                    { name: 'menuActiveLeads', description: 'When "use-menu" prop is set to true, sets the items to display in the dropdown menu content for active leads. Here is where you will usually loop through items using HbMiniProfileItem. ' },
                ],
                eventHeaders: [
                    { text: 'Name', value: 'name' },
                    { text: 'Description', value: 'description' },
                ],
                eventItems: [
                    { name: '@click', description: 'Event for when anywhere is clicked except for the other click event areas in the rest of this list.' },
                    { name: '@avatar-click', description: 'Event for when the avatar is clicked.' },
                    { name: '@contact-space-click', description: 'Event for when the contact single occupied space icon and occupied space number text is clicked.' },
                    { name: '@phone-call-click', description: 'Event for when the prop "allow-phone-click" is set to true and the "Phone ##########" menu option is clicked.' },
                    { name: '@phone-text-click', description: 'Event for when the prop "allow-phone-click" is set to true and the "Text ##########" menu option is clicked.' },
                    { name: '@email-click', description: 'Event for when the prop "allow-email-click" is set to true and the email link is clicked.' },
                    { name: '@lead-click', description: 'Event for when the lead type text is clicked.' },
                    { name: '@access-click', description: 'Event for when the single occupied space access code is clicked.' },
                    { name: '@emitType', description: 'Event that emits the type of HbStatus color. Expected emitted values are "success", "caution", "error", "guidance", and "default". This is helpful for when you need to set the background color to match the same color scheme as the HbStatus chip and you can use these five values to pivot around. See design system "Color System" -> "Status Shade Colors" for proper background shade colors to set for the correlating 5 options or reference the examples and code in this documentation as a starting point.' },
                ],
                itemPropHeaders: [
                    { text: 'Name', value: 'name', width: '125' },
                    { text: 'Type', value: 'type' },
                    { text: 'Default', value: 'default', width: '100' },
                    { text: 'Description', value: 'description' },
                ],
                itemPropItems: [
                    { name: 'type', type: 'string', default: 'undefined', description: 'Sets the type of the item you will be using. Possible options are "space", "lead", or "closed".' },
                    { name: 'space-type', type: 'string', default: 'undefined', description: 'Sets the space type to show the appropriate icons when using "space" type. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'disable-click', type: 'boolean', default: 'false', description: 'Set to true to disable the main click event.' },
                    { name: 'space-number', type: 'string', default: 'undefined', description: 'Sets the space number to show when using "space" type.' },
                    { name: 'disable-space-link', type: 'boolean', default: 'false', description: 'Set to true to disable the link and disable the blue color of the space icon and number when using "space" type.' },
                    { name: 'space-category', type: 'string', default: 'undefined', description: 'Sets the space category to show when using "space" type.' },
                    { name: 'space-featured-amenity', type: 'string', default: 'undefined', description: 'Sets the space featured amenity to show when using "space" type.' },
                    { name: 'space-category', type: 'string', default: 'undefined', description: 'Sets the space category text for "space" type usages.' },
                    { name: 'space-property-info', type: 'string', default: 'undefined', description: 'Sets the space property info text for "space" type usages.' },
                    { name: 'space-access-code', type: 'string', default: 'undefined', description: 'Sets the space access code number text for "space" type usages.' },
                    { name: 'space-lockout', type: 'boolean', default: 'false', description: 'Set to true to turn the space access code icon to red with a slash through it for "space" type usages.' },
                    { name: 'disable-space-access-click', type: 'boolean', default: 'false', description: 'Set to true disable the "access-click" event when the contact space access code is clicked and turn off the hand pointer.' },
                    { name: 'space-status', type: 'string', default: 'undefined', description: 'Sets the status chip text for "space" type usages. Color will be set automatically by the text string used.' },
                    { name: 'disable-space-status', type: 'boolean', default: 'false', description: 'Set to true to disable the display of the "space-status" fo "space" type usages.' },
                    { name: 'lead-type', type: 'string', default: 'undefined', description: 'Sets the lead type text when using "lead" type.' },
                    { name: 'disable-lead-link', type: 'boolean', default: 'false', description: 'Set to true to disable the link and disable the blue color of the lead type text when using "lead" type.' },
                    { name: 'lead-space-type', type: 'string', default: 'undefined', description: 'Sets the lead space type to show the appropriate icons when using "lead" type. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'lead-space-number', type: 'string', default: 'undefined', description: 'Sets the lead space number to show when using "lead" type.' },
                    { name: 'lead-space-category', type: 'string', default: 'undefined', description: 'Sets the lead space category text when using "lead" type.' },
                    { name: 'lead-featured-amenity', type: 'string', default: 'undefined', description: 'Sets the lead space featured amenity text when using "lead" type.' },
                    { name: 'lead-property-info', type: 'string', default: 'undefined', description: 'Sets the lead space property info text when using "lead" type.' },
                    { name: 'closed-space-type', type: 'string', default: 'undefined', description: 'Sets the lead space type to show the appropriate icons when using "closed" type. Refer to the design system "tokens.js" file for all possible space types that can be passed into this prop.' },
                    { name: 'closed-count', type: 'number', default: '0', description: 'Sets the number count of closed leases for "closed" type.' },
                    { name: 'closed-status', type: 'string', default: 'undefined', description: 'Sets the status chip text for "closed" type usages. Color will be set automatically by the text string used.' },
                    { name: 'disable-closed-status', type: 'boolean', default: 'false', description: 'Set to true to disable the display of the "closed-status" for "closed" type usages.' },
                ],
                itemEventHeaders: [
                    { text: 'Name', value: 'name' },
                    { text: 'Description', value: 'description' },
                ],
                itemEventItems: [
                    { name: '@click', description: 'Event for when anywhere is clicked except the click event areas in the rest of this list.' },
                    { name: '@space-click', description: 'Event for when contact single occupied space icon and occupied space number text is clicked.' },
                    { name: '@lead-click', description: 'Event for when lead type text is clicked.' },
                    { name: '@access-click', description: 'Event for when the single occupied space access code is clicked.' },
                ],
            };
        },
        methods: {
            handleEmittedClickEvent(e, component){
                this.success = true;
                this.description = "This " + e + " action is emitted from it's base level custom component.";
                this.lastEmittedEvent = e;
                this.fromComponent = component;
            }
        },
        watch:{
            type(){
                if(this.type === 'contact' || this.type === 'lead'){
                    this.title = 'Harry Potter'
                } else if(this.type === 'business'){
                    this.title = 'Hogwarts Academy';
                } else if(this.type === 'space'){
                    this.title = '100';
                } else if(this.type === 'account'){
                    this.title = 'Hogwarts Account';
                }
            },
        },
    }
</script>

<style scoped>

</style>
